import { Dimmer, Loader } from "semantic-ui-react";

const LoadingSpinner = () => {
    return <div style={{ width: '100vw', height: '100vh', backgroundColor: 'rgba(255, 255, 255, 1)' }}>
        <Dimmer active >
            <Loader active size='big'>Prosím čakajte...</Loader>
        </Dimmer>
    </div>
}


export default LoadingSpinner;